<template>
  <div class="">

    <div class="flex justify-center">
      <span class="text-center text-3xl font-black text-black">Change background</span>
    </div>


      <div v-if="$store.getters.backgroundImageName" class="m-8 border border-dashed hover:border-transparent">
        <div class="text-black text-xl h-32 cursor-pointer border-solid border-1 border-transparent hover:border-black justify-center items-center flex" @click="$store.dispatch('CHANGE_BACKGROUND', {backgroundImageName: null})">
          <feather-icon  icon="Trash2Icon" class="w-5 mr-1"/><span>without wallpaper</span>
      </div>
    </div>

    <div v-lazy-container="{ selector: 'img', loading: 'xxx.jpg' }">
      <div v-for="image in imageOptions" :key="image" >
        <div class="m-8 ">
          <img :data-src="getImage(image)" class="cursor-pointer  border-solid border-1 border-transparent hover:border-black" @click="$store.dispatch('CHANGE_BACKGROUND', {backgroundImageName: image})">
        </div>
      </div>
    </div>



  </div>
</template>
<script>

// import { midnight, isPast, daysFromDate } from '@/helpers/date'
export default {
  components: {
  },
  props: [],
  data () {
    return {
      imageOptions: [
        'wallpaper_1.png',
        'wallpaper_2.png',
        'wallpaper_3.png',
        'wallpaper_4.png',
        'wallpaper1.png',
        'wallpaper2.png',
        'wallpaper3.png',
        'wallpaper4.png',
        'wallpaper5.png',
        'wallpaper6.png',
        'wallpaper7.png',
        'wallpaper8.png',
        'wallpaper9.png',
        'wallpaper10.png',
        'wallpaper11.png',
        'wallpaper12.png',
        'wallpaper13.png',
        'wallpaper14.png',
        'wallpaper15.png',
        'wallpaper16.png',
        'wallpaper17.png',
      ]
    }
  },
  computed: {
    liClases () {
      if (this.disabled) {
        return `disabled opacity-50 ${this.textColor}`
      } else {
        return `cursor-pointer hover:font-semibold hover:bg-grey-light hover:rounded ${this.textColor}`
      }
    },
  },
  methods: {
    getImage (filename) {
      return require(`@/assets/images/wallpapers/${filename}`)
    },
  }
}
</script>

<style scoped>
</style>
